//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

  name: "v-icon",

  props: {
    viewBox: { type: String, default: "0 0 24 24" },
    iconName: { type: String, default: "" },
    width: { type: [Number, String], default: 18 },
    height: { type: [Number, String], default: 18 },
    iconColor: { type: String, default: "currentColor" },
  },

}
